/* eslint-disable react/no-multi-comp */
import React, { Fragment } from "react";
import { bool, string, array, func } from "prop-types";
import logoImage from "../../Resources/Images/Logos/logo-life-seguros-2.svg";
import { GLOBAL } from "../../Config/global";
import userAuth from "../../Config/userauth";
import * as QLIBS from '../../qLibsHelpers';
import { APPCONFIG } from '../../app.config';
import { withRouter } from '../../utils/routerHelpers';
import { Nav, NavDropdown, Navbar, Button } from 'react-bootstrap';
import Tooltip from '../Tooltip';
import NavDropdownMenuItem from '../NavDropdownMenuItem';
import NavDropdownMenu from '../NavDropdownMenu';
import ProfileBadge from '../ProfileBadge';
import NotificationCounter from '../NotificationCounter';
import ConfirmationModal from '../ConfirmationModal';
import { USER_TOKEN } from '../../Config/userToken';
import * as utils from '../../Shared/Utils';
import { APIS } from '../../Config/apis';
import { DEFAULT_HEADER } from '../../Config/userToken';
import './styles.scss';

//const timeout = 15 * 1000; // 15 segundos
//const timeout = 60 * 1000; // un minuto
const timeout = 15 * 60 * 1000; // 15 minutos
//const timeout = 6 * 10 * 60000; // una hora
let menuOptionCount = 0;

class Header extends React.Component {

    constructor(props) {
        super(props);

        const shouldStartMenuLoading =
            props.showNavbar &&
            userAuth.isAuthenticated() &&
            !(userAuth.userIdProducer() === undefined && userAuth.isAdmin()) &&
            !(userAuth.isUserSimulator() && userAuth.requestSelectProducer());

        this.state = {
            expanded: false,
            isOpen: false,
            isMenuLoading: shouldStartMenuLoading,
            showNotificationPanel: false,
            showLogoutModal: false,
            showNotification: false,
            notifications: [],
            menu: [],
            menuSelected: utils.getStorage('menu-selected') ? parseInt(utils.getStorage('menu-selected')) : 0
        };

        // Inicializar variables para tracking de cambios
        this._prevUserIdProducer = userAuth.userIdProducer();
        this._prevIsAuthenticated = userAuth.isAuthenticated();

        // Inicializar variable para el intervalo de refresco de token
        this.tokenRefreshInterval = null;

        this.loadMenu = this.loadMenu.bind(this);
        this.notificationCounterChange = this.notificationCounterChange.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onSelectMenu = this.onSelectMenu.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentDidMount() {
        if (userAuth.isAuthenticated()) {
            this.verifyVersion();
            this.loadPermissions();
            this.loadNotifications();
        }

        if (this.props.token) {
            this.tokenRefreshInterval = setInterval(() => {
                USER_TOKEN.refresh_token();
            }, timeout);
        }

        this.setActiveMenuFromLocation();
    }

    componentDidUpdate(prevProps) {
        // Guardar estado anterior para comparación
        const prevUserIdProducer = this._prevUserIdProducer;
        const prevIsAuthenticated = this._prevIsAuthenticated;

        // Obtener estado actual
        const currentUserIdProducer = userAuth.userIdProducer();
        const currentIsAuthenticated = userAuth.isAuthenticated();

        // Actualizar estado guardado
        this._prevUserIdProducer = currentUserIdProducer;
        this._prevIsAuthenticated = currentIsAuthenticated;

        // Manejar el intervalo cuando cambia el token
        if (prevProps.token !== this.props.token) {
            if (this.tokenRefreshInterval) {
                clearInterval(this.tokenRefreshInterval);
                this.tokenRefreshInterval = null;
            }

            if (this.props.token) {
                this.tokenRefreshInterval = setInterval(() => {
                    USER_TOKEN.refresh_token();
                }, timeout);
            }
        }

        // Verificar si cambió el productor simulado o el estado de autenticación
        if (currentIsAuthenticated &&
            (prevUserIdProducer !== currentUserIdProducer ||
                prevIsAuthenticated !== currentIsAuthenticated)) {

            // Limpiar menú anterior y recargar
            this.setState({ menu: [], isMenuLoading: true }, () => {
                this.loadPermissions();
                this.loadNotifications();
            });
        }

        if (prevProps.location?.pathname !== this.props.location?.pathname) {
            this.setActiveMenuFromLocation();
        }
    }

    renderOptions(menu, levelCount = 0, menuPlacement = 'right') {
        return (
            <NavDropdownMenu key={(`menu_option_${menuOptionCount++}`).toString()}
                nested={Boolean(levelCount)}
                menuPlacement={menuPlacement}
                className='menu-header'>
                {menu.options.map(option => {
                    const increasedLevelCount = levelCount + 1;
                    return (
                        <NavDropdownMenuItem key={(`menu_option_${menuOptionCount++}`).toString()} item={option}>
                            {option.options && this.renderOptions(option, increasedLevelCount, menu.menuPlacement)}
                        </NavDropdownMenuItem>
                    );
                })}
            </NavDropdownMenu>
        );
    }

    renderMenuOptions(menu, levelCount = 0, menuPlacement = 'right') {
        return (
            <NavDropdown
                key={(`menu_option_${menuOptionCount++}`).toString()}
                title={(menu.icon ? <><i className={menu.icon}></i>&nbsp;{menu.label}</> : menu.label)}
                id={`basic-nav-dropdown-${levelCount}`}
                className={`dropdown-menu-${menuPlacement}`}
                onMouseEnter={this.handleOpen}
                onMouseLeave={this.handleClose}
            >
                {menu.options.map((option, index) => {
                    const increasedLevelCount = levelCount + 1;
                    return (
                        option && option.label && option.link ? (
                            <React.Fragment key={`menu_option_${menuOptionCount++}`}>
                                <NavDropdown.Item
                                    onClick={() => this.handleMenuNavigation(option)}
                                >
                                    {option.icon ? option.placement === "right" ? <>{option.label}&nbsp;<i className={option.icon}></i></> : <><i className={option.icon}></i>&nbsp;{option.label}</> : option.label}
                                </NavDropdown.Item>
                                {(menu.options.length !== index + 1) && <NavDropdown.Divider />}
                            </React.Fragment>
                        )
                            : (
                                option.options && this.renderMenuOptions(option, increasedLevelCount, menu.menuPlacement)
                            )
                    );
                })}
            </NavDropdown>
        );
    }

    handleMenuNavigation = (option, shouldSelect = false) => {
        if (!option?.link) {
            return;
        }

        if (option.link.startsWith('http://') || option.link.startsWith('https://')) {
            window.open(option.link, '_blank', 'noopener,noreferrer');
            return;
        }

        this.props.navigate(option.link);

        if (shouldSelect) {
            this.onSelectMenu(option.link);
        }
    }

    handleOpen = () => {
        this.setState({ isOpen: true })
    }

    handleClose = () => {
        this.setState({ isOpen: false })
    }

    loadPermissions() {
        this.setState({ isMenuLoading: true });
        // Para administradores, cargar menú por defecto
        if (userAuth.userIdProducer() === undefined && userAuth.isAdmin()) {
            //  this.loadMenu(['Administracion', 'Marketing']);
            this.setState({ isMenuLoading: false });
            return;
        }

        // Si es un simulador que necesita seleccionar productor, no cargar menú
        if (userAuth.isUserSimulator() && userAuth.requestSelectProducer()) {
            this.setState({ isMenuLoading: false });
            return;
        }

        let api = '';

        if (userAuth.userIdProducer() !== undefined || userAuth.isAdmin()) {
            api = APPCONFIG.ENDPOINTS.PRODUCERURL + "api/simulator/getpermissionsproducersimulator?userIdProducer=" + userAuth.userIdProducer() + '&userId=' + userAuth.simulatorUserId();
        } else if (userAuth.userId() !== undefined) {
            api = APPCONFIG.ENDPOINTS.PRODUCERURL + "api/login/roles?userId=" + userAuth.userId();
        }

        if (api) {
            fetch(api)
                .then((response) => {
                    if (response.ok) {
                        response.json().then(this.loadMenu);
                    } else {
                        console.error('Error loading permissions:', response.status);
                        this.loadMenu(['Marketing']);
                    }
                })
                .catch((error) => {
                    console.error('Error loading permissions:', error);
                    this.loadMenu(['Marketing']);
                });
        } else {
            this.loadMenu(['Marketing']);
        }

    }

    loadMenu(data) {
        const { COMPONENTS_FORM: { MENUS } } = GLOBAL;

        const isProducer = userAuth.isProducer();
        const permissions = [...data];

        if (permissions && permissions.length > 0 && permissions.indexOf('logout') > -1) {
            userAuth.signout(() => { this.logout(isProducer); });
            return;
        }

        if (permissions.filter(item => { return item === 'BusquedaCartera' || item === 'LibreDeuda' }).length > 0) {
            permissions.push('Cartera');
        }

        if (permissions.filter(item => { return item === 'LiquidacionCC' || item === 'BusquedaCartera' || item === 'EnvioFacturas' }).length > 0) {
            permissions.push('CuentaCorriente');
        }

        if (permissions.filter(item => { return item === 'RechazoMotivo' || item === 'DeudoresPremio' }).length > 0) {
            permissions.push('Cobranzas');
        }

        permissions.push('Marketing');

        let result = [];
        for (let index = 0; index < permissions.length; index++) {
            let menu = MENUS.filter(item => { return item.permissionName === permissions[index]; })[0];
            //// 
            if (menu !== undefined && menu.nivel === 1) {
                menu = this.cloneMenuItem(menu);
                if (menu && menu.options.length) {
                    menu.options = menu.options.sort((a, b) => a.order - b.order);
                    menu.options = this.buildChildMenu(menu.options, permissions);
                    result.push(menu);
                }
                else if (menu) {
                    result.push(menu);
                }
            }
        }
        result = result.sort((a, b) => a.order - b.order);
        this.setState({ menu: result, isMenuLoading: false }, () => {
            // Establecer el menu activo después de cargar el menú
            this.setActiveMenuFromLocation();
        });

    }

    renderMenuSkeleton() {
        return (
            <div className="menu-nav menu-nav-skeleton" role="status" aria-label="Cargando menu">
                <div className="header-nav header-nav-skeleton">
                    {[0, 1, 2, 3, 4].map((item) => (
                        <div key={`menu_skeleton_${item}`} className="menu-skeleton__item skeleton-shimmer" />
                    ))}
                </div>
            </div>
        );
    }

    loadNotifications() {
        // Si es un simulador que necesita seleccionar productor, no cargar notificaciones
        if (userAuth.isUserSimulator() && userAuth.requestSelectProducer()) {
            return;
        }

        const cuit = userAuth.isProducer() ? userAuth.cuit() : userAuth.cuitProducer();
        if (cuit !== null && cuit !== undefined) {
            let urlApi = APPCONFIG.ENDPOINTS.PRODUCERURL + "api/notification/notificationsearch?CUIT=" + cuit + "&Nuevos=true&WebUse=true&MailUse=false";
            if (urlApi) {
                QLIBS.fetchDataGET(urlApi, true)
                    .then((response) => {
                        let notifications = response.map(e => ({
                            id: e.id,
                            title: e.WebTitle,
                            body: e.WebText,
                            showBody: false,
                            link: e.WebLink
                        }));
                        this.setState({ notifications: notifications, showNotification: true });
                    })
                    .catch((error) => {
                        console.error('Error loading notifications:', error);
                    });
            }
        }
    }

    verifyNotification(id) {
        const cuit = userAuth.isProducer() ? userAuth.cuit() : userAuth.cuitProducer();
        if (cuit !== null && cuit !== undefined) {
            let urlApi = APPCONFIG.ENDPOINTS.PRODUCERURL + "api/notification/notificationwebverify?CUIT=" + cuit + "&id=" + id;
            if (urlApi) {
                QLIBS.fetchDataGET(urlApi, true)
                    .then((response) => {
                        this.loadNotifications();
                    })
                    .catch((error) => {
                        console.error('Error verifying notification:', error);
                    });
            }
        }
    }

    verifyVersion() {
        let urlApi = APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Login/GetAppVersion';
        if (urlApi) {
            QLIBS.fetchDataGET(urlApi, true)
                .then((appVersion) => {
                    const localAppVersion = userAuth.getAppVersion();
                    if (localAppVersion === null || localAppVersion !== appVersion) {
                        userAuth.setAppVersion(appVersion);
                        this.emptyCache();
                    }
                })
                .catch((error) => {
                    console.error('Error verifying version:', error);
                });
        }
    }

    emptyCache() {
        if ('caches' in window) {
            caches.keys().then((names) => {
                names.forEach(name => {
                    caches.delete(name);
                })
            });
            window.location.reload(true);
        }
    }

    buildChildMenu(menus, data) {

        let result = [];
        for (let index = 0; index < data.length; index++) {
            //// 
            if (menus !== undefined) {
                let menu = menus.filter(item => { return item.permissionName === data[index]; })[0];
                if (menu) {
                    menu = this.cloneMenuItem(menu);
                    let opt = menu.options;
                    menu.options = []
                    menu.options = this.buildChildMenu(opt, data);
                    result.push(menu);
                }
            }
        }
        return result.sort((a, b) => a.order - b.order);
    }

    cloneMenuItem(menu) {
        return {
            ...menu,
            options: menu.options ? menu.options.map(option => this.cloneMenuItem(option)) : []
        };
    }

    logout = (isProducer) => {
        // Guardar el ID del usuario antes de limpiar la autenticación
        const userId = userAuth.userId();

        // Primero limpiar la autenticación local
        userAuth.signout(() => {
            // Luego ejecutar el logout en el servidor con el ID guardado
            this.executeLogOff(userId);
        });
    }

    onSelectMenu = (e) => {
        let index = this.state.menu.findIndex(x => x.link === e);
        utils.setStorage('menu-selected', index);
        this.setState({ menuSelected: index });
    }

    setActiveMenuFromLocation = () => {
        const { location } = this.props;
        const { menu } = this.state;

        if (!location?.pathname || menu.length === 0) {
            return;
        }

        // Buscar el índice del menú que corresponde a la ruta actual
        const activeIndex = menu.findIndex(menuItem => {
            // Primero verificar si el menú principal coincide directamente
            if (menuItem.link && !menuItem.link.startsWith("http")) {
                if (location.pathname === menuItem.link ||
                    location.pathname.startsWith(menuItem.link + '/')) {
                    return true;
                }
            }

            // Siempre verificar las opciones hijas, incluso si el menú padre no tiene link
            if (menuItem.options && menuItem.options.length > 0) {
                return this.checkChildOptionsMatch(menuItem.options, location.pathname);
            }

            return false;
        });

        // Actualizar el estado si se encontró un menú activo
        if (activeIndex !== -1) {
            this.setState({ menuSelected: activeIndex });
            utils.setStorage('menu-selected', activeIndex);
        }
    }

    checkChildOptionsMatch = (options, pathname) => {
        // Recursivamente verificar si alguna opción hija coincide con la ruta actual
        for (const option of options) {
            if (option.link && !option.link.startsWith("http")) {
                if (pathname === option.link || pathname.startsWith(option.link + '/')) {
                    return true;
                }
            }

            // Verificar opciones anidadas
            if (option.options && option.options.length > 0) {
                if (this.checkChildOptionsMatch(option.options, pathname)) {
                    return true;
                }
            }
        }

        return false;
    }

    executeLogOff(userId) {
        const requestOptions = {
            method: 'POST',
            headers: DEFAULT_HEADER.get(),
            body: JSON.stringify({
                userid: userId
            })
        };
        fetch(APIS.URLS.LOGOUT, requestOptions)
            .then(() => {
                this.props.navigate('/login')
            })
            .catch((error) => {
                console.error('Error during logout:', error);
                // Incluso si hay error en el servidor, redirigir al login
                this.props.navigate('/login');
            });
    }

    componentWillUnmount() {
        if (this.tokenRefreshInterval) {
            clearInterval(this.tokenRefreshInterval);
        }
    }

    notificationCounterChange(id) {
        if (id !== null) {
            this.verifyNotification(id);
        }
    }

    render() {
        const { USER_DASHBOARD: { LOGOUT_MODAL } } = GLOBAL;

        menuOptionCount = 0;

        return (
            <div className="header">
                <Fragment>
                    {this.state.showLogoutModal && (
                        <ConfirmationModal
                            message={LOGOUT_MODAL.BODY}
                            title={LOGOUT_MODAL.TITLE}
                            onDismiss={() => this.setState({ showLogoutModal: false })}
                            onConfirm={() => {
                                const isProducer = userAuth.isProducer();
                                this.logout(isProducer);
                            }}
                        />
                    )}
                    <>
                        <Navbar key={'navbar_' + this.props.showNavbar} expand="lg" className={`${this.props.showNavbar ? "" : "shadowed"}`}>

                            <div className="container ">
                                <Navbar.Brand
                                    onClick={() => this.props.navigate('/')}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <img
                                        src={logoImage}
                                        className="header__logo"
                                        alt="Life Seguros logo"
                                    />
                                    {this.props.channelLogo.length ?
                                        <img className="ml-4 channel-logo d-none d-md-flex"
                                            src={this.props.channelLogo}
                                            alt="Logo del canal" />
                                        : null
                                    }
                                </Navbar.Brand>
                            </div>
                            {this.props.showProfileBadge && (
                                <>
                                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                    <Navbar.Collapse id="basic-navbar-nav">
                                        <Nav className="mr-auto  ">
                                            {(userAuth.userIdProducer() !== undefined) && (
                                                <Nav.Item key={'simulate-nav'}>
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <Button variant="secondary" size="sm" onClick={() => { userAuth.cleanSimulator(); this.props.navigate("/simulate-producer"); }}>
                                                            {`Simulando productor (${userAuth.userNameProducer()}) ${userAuth.cuitProducer()}`}&nbsp;<i title="Cambiar productor" className="bi bi-x"></i>
                                                        </Button>
                                                    </div>
                                                </Nav.Item>
                                            )}
                                        </Nav>
                                        <Nav className="ms-auto align-items-center" navbar={true}>
                                            <div className="notification-counter-wrapper">
                                                <NotificationCounter data={this.state.notifications} visible={this.state.showNotification} onChange={this.notificationCounterChange} />
                                            </div>
                                            <Nav.Link key={'avatar'} className="avatar-header">
                                                <ProfileBadge height="35" width="35" inHeader image={userAuth.userAvatar()} />
                                            </Nav.Link>
                                            <Nav.Item className="userMenu">
                                                <NavDropdown key={'userName'} title={userAuth.userName() ? userAuth.userName().toUpperCase() : 'CARGANDO...'} id="collasible-nav-dropdown">
                                                    {(userAuth.isProducer() || userAuth.userIdProducer() !== undefined) && utils.getStorage('menuAdvanced') !== "true" && (
                                                        <>
                                                            <NavDropdown.Item onClick={() => { this.props.navigate('/user-dashboard-info'); }}>
                                                                <i className="bi bi-person-fill me-2"></i>
                                                                Editar perfil
                                                            </NavDropdown.Item>
                                                            <NavDropdown.Divider />
                                                            <NavDropdown.Item key={'delegado'} onClick={() => { this.props.navigate('/delegado'); }}>
                                                                <i className="bi bi-person-plus-fill me-2"></i>
                                                                Agregar subusuario
                                                            </NavDropdown.Item>
                                                            <NavDropdown.Divider />

                                                        </>
                                                    )}
                                                    {userAuth.isUserSimulator() && (
                                                        <>
                                                            <NavDropdown.Item key={'change'} onClick={() => { userAuth.cleanSimulator(); this.props.navigate('/simulate-producer') }}>
                                                                <i className="bi bi-arrow-repeat me-2"></i>
                                                                Cambiar productor / Avanzado
                                                            </NavDropdown.Item>
                                                            <NavDropdown.Divider />
                                                        </>
                                                    )}
                                                    {userAuth.isAdmin() && (
                                                        <>
                                                            <NavDropdown.Item key={'change'} onClick={() => { userAuth.cleanSimulator(); this.props.navigate('/avanzadas') }}>
                                                                <i className="bi bi-tools me-2"></i>
                                                                Herramientas
                                                            </NavDropdown.Item>
                                                            <NavDropdown.Divider />
                                                        </>
                                                    )}
                                                    <NavDropdown.Item key={'salir'} onClick={() => { this.setState({ showLogoutModal: true }) }}>
                                                        <i className="bi bi-box-arrow-right me-2"></i>
                                                        Salir
                                                    </NavDropdown.Item>
                                                </NavDropdown>
                                            </Nav.Item>
                                        </Nav>
                                    </Navbar.Collapse>
                                </>
                            )}
                        </Navbar>
                        {this.props.showNavbar && this.state.isMenuLoading && this.renderMenuSkeleton()}
                        {this.props.showNavbar && !this.state.isMenuLoading && this.state.menu.length > 0 && (
                            <div className="menu-nav " >
                                <Nav id="menu" className="justify-content-center header-nav" activeKey="/home">
                                    {this.state.menu.map((menu, index) => {
                                        const key = `menu_option_${menuOptionCount++}`;
                                        return (
                                            <React.Fragment key={key}>
                                                {(menu.options.length) === 0 ? (
                                                    <Nav.Item key={key}>
                                                        <Nav.Link
                                                            onClick={() => this.handleMenuNavigation(menu, true)}
                                                            className={menu.className}
                                                        >
                                                            <Tooltip
                                                                text={menu.tooltip || ''}
                                                                id={`menu-tooltip-${index}`}
                                                                placement="top"
                                                                disabled={!menu.tooltip}
                                                            >
                                                                <p className={this.state.menuSelected === index ? "menu-bold" : ""}>
                                                                    {menu.icon ? menu.placement === "right" ? <>{menu.label}&nbsp;<i className={menu.icon}></i></> : <><i className={menu.icon}></i>&nbsp;{menu.label}</> : menu.label}
                                                                </p>
                                                            </Tooltip>
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                ) : (
                                                    <Tooltip
                                                        text={menu.tooltip || ''}
                                                        id={`dropdown-tooltip-${index}`}
                                                        placement="top"
                                                        disabled={!menu.tooltip}
                                                    >
                                                        <div className={this.state.menuSelected === index ? "menu-bold" : ""}>
                                                            {this.renderMenuOptions(menu)}
                                                        </div>
                                                    </Tooltip>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}

                                </Nav>
                            </div>
                        )}
                    </>
                </Fragment>
            </div>
        );
    }
}

Header.defaultProps = {
    showBackButton: true,
    centered: false,
    channelLogo: '',
    showHamburgerMenu: false,
    showNavbar: false,
    showProfileBadge: false,
    showNotificationPanel: false,
    notifications: [],
    token: false,
    push: () => { }
};

Header.propTypes = {
    menuItems: array,
    centered: bool,
    channelLogo: string,
    showBackButton: bool,
    showHamburgerMenu: bool,
    showNavbar: bool,
    showProfileBadge: bool,
    showNotificationPanel: bool,
    token: bool,
    push: func
};

export default withRouter(Header);
